// This icon file is generated automatically.
var PtoLayoutSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M27.5 3.5h-23a1 1 0 00-1 1v23a1 1 0 001 1h23a1 1 0 001-1v-23a1 1 0 00-1-1zM5.75 5.75H10v20.5H5.75V5.75zm20.5 20.5H12V12h14.25v14.25zM12 10V5.75h14.25V10H12z", "fill-rule": "nonzero" } }] }, "name": "pto-layout-square", "theme": "outlined" };
export default PtoLayoutSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoLayoutSquareOutlined.js
// module id = 3906
// module chunks = 0